import React from "react";

export class Uppercase extends React.Component<React.PropsWithChildren<{}>> {
    public render (): JSX.Element {
        return (
            <span className="uppercase">{this.props.children}</span>
        );
    }
}
